import logo from './logo.svg';
import './App.css';
import AllRouter from './Pages/AllRouter';

function App() {
  return (
    <div >
      <AllRouter/>
    </div>
  );
}

export default App;
